import axios from 'axios';

const API_BASE_URL = 'https://backend.gouniquejourneys.co.uk/api/employee'; // Adjust if needed

// Fetch assigned flight bookings

export const getAssignedFlights = async (employeeId, { page, limit, sort }) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/bookings/assigned-flights/${employeeId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: { page, limit, sort }, // Send filters as query params
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching assigned flight bookings:', error.response?.data || error.message);
    throw error;
  }
};

// Update flight booking
export const updateFlightBooking = async (bookingId, updatedData) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/bookings/update-flight-booking/${bookingId}`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating flight booking:', error.response?.data || error.message);
    throw error;
  }
};

//comment for tour
export const addCommentTour = async (conversationData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/bookings/add-comment-tour`, conversationData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error adding conversation:', error.response?.data || error.message);
    throw error;
  }
};

export const addCommentHotel = async (conversationData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/bookings/add-comment-hotel`, conversationData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error adding conversation:', error.response?.data || error.message);
    throw error;
  }
};

export const addCommentFlight = async (conversationData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/bookings/add-comment-flight`, conversationData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error adding conversation:', error.response?.data || error.message);
    throw error;
  }
};
//fetch hotel & tour
export const getAssignedBookings = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/bookings/all-bookings`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: { page, limit }, // Sending query parameters
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching assigned bookings:', error.response?.data || error.message);
    throw error;
  }
};

// Fetch assigned hotel bookings
export const getAssignedHotels = async (employeeId, { page = 1, limit = 10, sort = 'newest' }) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/bookings/assigned-hotels/${employeeId}`, {
      params: { page, limit, sort }, // Passing query parameters
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching assigned hotel bookings:', error.response?.data || error.message);
    throw error;
  }
};

// Update hotel booking
export const updateHotelBooking = async (bookingId, updatedData) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/bookings/update-hotel-booking/${bookingId}`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating hotel booking:', error.response?.data || error.message);
    throw error;
  }
};

// Fetch assigned tour bookings
export const getAssignedTours = async (employeeId, { page = 1, limit = 10, sort = 'newest' }) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/bookings/assigned-tour/${employeeId}`, {
      params: { page, limit, sort }, // Passing query parameters

      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching assigned tour bookings:', error.response?.data || error.message);
    throw error;
  }
};

// Update tour booking
export const updateTourBooking = async (bookingId, updatedData) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/bookings/update-tour-booking/${bookingId}`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating tour booking:', error.response?.data || error.message);
    throw error;
  }
};

// Update tour booking
export const updateTourAgent = async (bookingId, updatedData) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/bookings/update-tour-agent/${bookingId}`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating tour booking:', error.response?.data || error.message);
    throw error;
  }
};

export const updateHotelAgent = async (bookingId, updatedData) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/bookings/update-hotel-agent/${bookingId}`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating tour booking:', error.response?.data || error.message);
    throw error;
  }
};
export const updateFlightAgent = async (bookingId, updatedData) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/bookings/update-flight-agent/${bookingId}`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating tour booking:', error.response?.data || error.message);
    throw error;
  }
};
